var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    bypassChooser: false,
    isVoted: {},
    declinedToVote: {},
    completedAcclaimedElections: {},
    slateListsExpanded: {},
};
export var extraSlice = createSlice({
    name: "extra",
    initialState: initialState,
    reducers: {
        setBypassChooser: function (state, action) {
            state.bypassChooser = action.payload;
            return state;
        },
        setIsVoted: function (state, action) {
            state.isVoted[action.payload] = true;
            return state;
        },
        setDeclinedToVote: function (state, action) {
            state.declinedToVote[action.payload] = true;
            return state;
        },
        clearDeclinedToVoteForElection: function (state, action) {
            delete state.declinedToVote[action.payload];
            return state;
        },
        completeAcclaimedElection: function (state, action) {
            state.completedAcclaimedElections[action.payload] = true;
            return state;
        },
        setSlateListExpanded: function (state, action) {
            var _a;
            var _b = action.payload, electionId = _b.electionId, slateId = _b.slateId, expanded = _b.expanded;
            state.slateListsExpanded[electionId] = __assign(__assign({}, state.slateListsExpanded[electionId]), (_a = {}, _a[slateId] = expanded, _a));
            return state;
        },
        clearIsVoted: function (state) {
            state.isVoted = {};
            state.declinedToVote = {};
            return state;
        },
    },
});
export var setBypassChooser = (_a = extraSlice.actions, _a.setBypassChooser), setIsVoted = _a.setIsVoted, setDeclinedToVote = _a.setDeclinedToVote, clearDeclinedToVoteForElection = _a.clearDeclinedToVoteForElection, completeAcclaimedElection = _a.completeAcclaimedElection, setSlateListExpanded = _a.setSlateListExpanded, clearIsVoted = _a.clearIsVoted;
export var selectBypassChooser = function () { return function (state) { return state.extra.bypassChooser; }; };
export var isVotedByElectionId = function (electionId) { return function (state) {
    return electionId ? state.extra.isVoted[electionId] : false;
}; };
export var isDeclineToVoteByElectionId = function (electionId) { return function (state) {
    return electionId ? Boolean(state.extra.declinedToVote[electionId]) : false;
}; };
export var isAcclaimedElectionCompleted = function (electionId) { return function (state) { var _a; return electionId ? Boolean((_a = state.extra.completedAcclaimedElections) === null || _a === void 0 ? void 0 : _a[electionId]) : false; }; };
export var selectSlateListExpanded = function (electionId, slateId) {
    return function (state) { var _a, _b; return (_b = (_a = state.extra.slateListsExpanded) === null || _a === void 0 ? void 0 : _a[electionId]) === null || _b === void 0 ? void 0 : _b[slateId]; };
};
export default extraSlice.reducer;
